import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'ReadTheRoom';
const DEFAULT_IMAGE = `${window.location.origin}/logo.png`;
const DEFAULT_DESC = 'The social reading platform built for book lovers in Lagos. Track your reading life, discover your people, and find your next great read.';

export default function SEOMeta({ title, description, image, type = 'website', noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Where Lagos Reads, Connects, and Shares`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
